import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import Login from "../pages/Authentication/Login"
import {
  getAuthenticatedHomePath,
  hasAuthSession,
} from "../helpers/routeAccess"

const LoginRoute = () => {
  const authToken = useSelector(state => state.auth.jid)
  const currentUser = useSelector(state => state.auth.currentUser)

  // Require a live token + user. User alone must not bounce to dashboard
  // (logout can briefly desync persist and cause login ↔ admin loops).
  if (hasAuthSession(authToken) && currentUser) {
    return <Navigate to={getAuthenticatedHomePath(currentUser)} replace />
  }

  return <Login />
}

export default LoginRoute
